module.exports = __webpack_public_path__ + "img/20241124_dongzhuer.c5bf3a43.jpg";